import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";

import { ErrorBoundary } from "./components/ui/ErrorBoundary";
import { FirstLaunchModal } from "./features/consent/FirstLaunchModal";
import { getConsent } from "./features/consent/store";
import { queryClient } from "./lib/queryClient";
import { initPostHog } from "./lib/posthog";
import { initSentry } from "./lib/sentry";
import { routes } from "./routes/config";

const router = createBrowserRouter(routes);

function App() {
  useEffect(() => {
    const consent = getConsent();
    if (consent.analytics) {
      initPostHog().catch((e) => console.error("[App] initPostHog failed", e));
    }
    if (consent.crashReports) {
      initSentry().catch((e) => console.error("[App] initSentry failed", e));
    }
  }, []);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <FirstLaunchModal />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
